/** DOM-free data values. Callers retain their gates, reporting and display normalization. */
export class kDataValueCore {
    /** DOCUMENTED EXCEPTION: pure data-plane predicate; callers own error handling. */
    public static IsBlank = (Value: unknown): boolean => {
        if (Value === null || Value === undefined) { return true; }
        if (typeof Value === "string" && Value.trim() === "") { return true; }
        return false;
    };

    /** DOCUMENTED EXCEPTION: pure conversion; blank/non-numeric values stay absent, not zero. */
    public static ToNumberOrNull = (Value: unknown): number | null => {
        if (kDataValueCore.IsBlank(Value)) { return null; }
        if (typeof Value === "number") {
            if (isNaN(Value)) { return null; }
            return Value;
        }
        if (typeof Value === "boolean") {
            if (Value === true) { return 1; }
            return 0;
        }
        const Num: number = Number(Value);
        if (isNaN(Num)) { return null; }
        return Num;
    };

    /** DOCUMENTED EXCEPTION: pure comparison; locale and sensitivity belong to caller policy. */
    public static NaturalCompare = (A: unknown, B: unknown, Culture: string | undefined,
        Sensitivity: "base" | "accent" | "case" | "variant" = "base"): number => {
        return String(A).localeCompare(String(B), Culture, { numeric: true, sensitivity: Sensitivity });
    };
}
